<script lang="ts">
      import { getHeaderVisiblityContext } from '$lib/ui/menu/index.svelte'
      import MenuArrow from '../MenuArrow.svelte'
      import MenuInlineItem from './MenuInlineItem.svelte'
      import { tick } from 'svelte'
      import { flip, menuCloseObserver } from '../MenuSubMenu.svelte'

      function toggleOpen() {
            return (open = !open)
      }

      async function handleClick(ev: Event) {
            if (open == true) return

            const button = ev.currentTarget as HTMLElement
            const menu = button.parentElement?.querySelector('.menu') as HTMLElement

            if (!menu) return

            await flip(menu, () => toggleOpen())
            ui.requestMenuVisible(menu)

            const { promise, resolve } = await menuCloseObserver(menu)
            closeOnClick = resolve

            await promise

            await flip(menu, () => toggleOpen())
            ui.releaseMenuVisible(menu)
      }

      function _onclick() {
            if (onclick) onclick()
            if (closeOnClick) {
                  closeOnClick()
                  closeOnClick = undefined
            }
      }

      let closeOnClick: undefined | Function
      const ui = getHeaderVisiblityContext()
      let menu: HTMLDivElement

      let { item, class: className = '', onclick, open = false } = $props()
</script>

<div class="relative label flex items-center text-right {className} ">
      <button onclick={handleClick} class="flex opacity-65 hover:opacity-100 uppercase relative items-center">
            <div>{item.label}</div>

            <MenuArrow class="" {open}></MenuArrow>
      </button>

      <div bind:this={menu} class="menu {open ? 'open' : ''} cursor-[default] -z-100 absolute flex flex-col gap-2 top-[110%] -right-3 w-max overflow-hidden rounded-lg">
            <div class="h-fit w-fit p-6 border-0 rounded-lg border-[#00000044] bg-[#FFFFFF]">
                  {#each item.items as line, i (i)}
                        <!--<p class="opacity-65 hover:opacity-100 leading-10 text-lg">{line.label}</p>-->
                        <MenuInlineItem onclick={_onclick} item={line} class="opacity-65 hover:opacity-100 w-full justify-end"></MenuInlineItem>
                  {/each}
            </div>
      </div>
</div>

<style lang="postcss">
      .menu {
            @apply shadow-xl;
            transform-origin: top;
            height: 0px;
      }

      .menu:global(.open) {
            height: initial;
      }
</style>
